// @flow
import SPCommitSummary from './SPCommitSummary';

export default SPCommitSummary;
